import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import api from '~/services/api';
import { Container } from '~/styles/pagesStyle';
import Card from './Card';

function MenuLista() {
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(false);
  const [modulos, setModulos] = useState([{}]);

  useEffect(() => {
    setLoading(true);
    async function getModulesData() {
      await api
        .get('/Modulo/GetPaginado/Page/1/Length/1000')
        .then((response) => {
          setModulos(response.data.registros);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Erro ao buscar dados dos módulos, recarregue a página');
          setLoading(false);
        });
    }
    getModulesData();
  }, []);

  async function handeGetMenusData(e) {
    setSelected(false);
    setLoading(true);
    e.preventDefault();
    setTimeout(() => {
      setSelected(true);
      setLoading(false);
    }, 250);
  }

  return (
    <Container>
      <Footer />
      <Menu />
      {Object.keys(modulos).length === 0 ? (
        <Spinner
          style={{ width: '3rem', height: '3rem', marginTop: '100px' }}
        />
      ) : (
        <Card
          modulos={modulos}
          loading={loading}
          selected={selected}
          setSelected={setSelected}
          handeGetMenusData={handeGetMenusData}
          setLoading={setLoading}
        />
      )}
    </Container>
  );
}

export default MenuLista;
